import { useCallback, useMemo, useState } from "react";

import { useNavigate } from "react-router-dom";

import { ROUTES } from "constants/routes";

import { validateEmail } from "utils/validators";

const useForgotPassword = () => {
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [validFieldError, setValidFieldError] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>("");
  const [infoModalIsOpen, setInfoModalIsOpen] = useState<boolean>(false);

  const navigate = useNavigate();

  const onInfoModalOpen = useCallback(() => setInfoModalIsOpen(true), []);

  const onInfoModalClose = useCallback(() => setInfoModalIsOpen(false), []);

  const handleRedirectToLogIn = useCallback(() => {
    onInfoModalClose();
    navigate(ROUTES.signIn);
  }, [navigate, onInfoModalClose]);

  const handleEmailChange = useCallback((value: string) => {
    setEmail(value);
    setValidFieldError(false);
    setErrorText("");
  }, []);

  const checkFieldValidation = useCallback(
    (value: string) => () => {
      if (!value) {
        setValidFieldError(true);
      } else if (!validateEmail(value)) {
        setValidFieldError(true);

        setErrorText("Please enter a valid email address");
      }
    },
    []
  );

  const formIsValid = useMemo(() => !!(email && validateEmail(email)), [email]);

  const handleFormClear = useCallback(() => {
    setEmail("");
  }, []);

  const handleSubmit = useCallback(() => {
    //FIXME: Add the real request to the BE
    if (formIsValid) {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
        handleFormClear();
        onInfoModalOpen();
        console.log("Submit");
      }, 3000);
    } else {
      checkFieldValidation(email)();
    }
  }, [
    checkFieldValidation,
    email,
    formIsValid,
    handleFormClear,
    onInfoModalOpen,
  ]);

  return {
    email,
    loading,
    validFieldError,
    errorText,
    infoModalIsOpen,
    handleEmailChange,
    handleSubmit,
    checkFieldValidation,
    onInfoModalClose,
    handleRedirectToLogIn,
  };
};

export default useForgotPassword;
